module.exports = __webpack_public_path__ + "img/4.cfa6d12f.jpg";